import { BASE_URL_API } from "../../../constants";
import { useAuthDetailStore, useAuthStore } from "../../../stores/useAuthStore";
import fetcher from "../../../utils/fetcher";

export const _api_get_detail_factsheet = async ({ selectedUserId = null }) => {
    return fetcher(
        `${BASE_URL_API}/onboarding/identity/details/${selectedUserId}`,
        {
            method: "GET",
            credentials: "include",
        }
    );
};

export const _api_send_reminder = async ({ id_user = null }) => {
    return fetcher(`${BASE_URL_API}/onboarding/identity/reminder/${id_user}`, {
        method: "POST",
        credentials: "include",
    });
};

export const _api_send_refuse = async ({ id_user = null, reason = "" }) => {
    return fetcher(`${BASE_URL_API}/onboarding/identity/${id_user}/decision`, {
        method: "DELETE",
        credentials: "include",
        body: JSON.stringify({ rejected_reason: reason }),
    });
};

export const _api_send_approve = async ({ id_user = null }) => {
    return fetcher(`${BASE_URL_API}/onboarding/identity/${id_user}/decision`, {
        method: "POST",
        credentials: "include",
    });
};

export const _getFactsheets = async ({ agencyId = null }) => {
    return fetcher(
        `${BASE_URL_API}/onboarding/agency/${agencyId}/identity/list`,
        {
            method: "GET",
            credentials: "include",
        }
    );
};
export const _getAllAgencies = async () => {
    return fetcher(BASE_URL_API + "/onboarding/agencies", {
        method: "GET",
        credentials: "include",
    });
};
export const _getCollaboratorByAgence = async (AgencyId) => {
    return fetcher(BASE_URL_API + `/onboarding/agency/${AgencyId}/users`, {
        method: "GET",
        credentials: "include",
    });
};
export const _startPreonboarding = async (user_id) => {
    return fetcher(
        BASE_URL_API +
            `/onboarding/user/${user_id?.id_task}/step/start_preonboarding`,
        {
            method: "PATCH",
            credentials: "include",
        }
    );
};
export const _relanceWelcomeMail = async (data) => {
    return fetcher(
        BASE_URL_API +
            `/onboarding/user/${data?.id}/step/resend_activation_email`,
        {
            method: "PATCH",
            credentials: "include",
        }
    );
};
export const _changeStatusOnboarding = (data) => {
    const change_date = data?.datefrom;
    const new_status = data?.status.id;
    const user_id = data?.user_id;
    return fetcher(
        BASE_URL_API +
            `/onboarding/user/${
                user_id?.id_user ?? user_id?.id_task
            }/step/change_status`,
        {
            method: "PATCH",
            // credentials: "include",
            headers: {
                "Content-Type": "application/json", // Définir le type de contenu
            },
            body: JSON.stringify({
                new_status, // Envoyer new_status dans le body
                change_date, // Envoyer change_date dans le body
            }),
        }
    );
};
export const _api_put_identity_form = () => {
    return fetcher(BASE_URL_API + `/user/${333}/profile/identity/form`, {
        method: "PUT",
        // credentials: "include",
        headers: {
            "Content-Type": "application/json", // Définir le type de contenu
        },
        body: JSON.stringify({
            personal_infos: {
                birth_name: "EL Yans",
                address: {
                    street: "12 rue de la Paix",
                    postal_code: "75001",
                    city: "Paris",
                    country: "FR",
                },
                nationality: "fr",
                working_permit: "D",
                birthdate: "1990-05-15",
                place_of_birth: "Lyon",
                country_of_birth: "FR",
                diploma: "Master",
                health_insurance: "CPAM",
                identity_card_type: 1,
                identity_card_number: "123456789",
                identity_card_expiry_date: "2030-12-31",
                avs: "",
                marital_status: 2,
                couple_registration_date: null,
            },
            partner: {
                full_name: "bens",
                birthdate: "1990-01-01",
                marriage_date: "2020-01-01",
                working_country: "fr",
                work_start_date: "2022-01-01",
                work_end_date: null,
                working_permit: "-",
                working_type: 0,
            },
            children: [
                {
                    first_name: "Yanis",
                    last_name: "Bens",
                    birthdate: "2023-01-01",
                    relationship: "parent",
                    address: "sfdsdfsdf",
                    parental_authority: "pere",
                },
            ],
            bank_account: {
                bank_name: "Ma Banque",
                iban: "CH93 0076 2011 6238 5295 7",
            },
            emergency_contacts: [
                {
                    full_name: "Jean Dupont",
                    phone_number: "0612345678",
                    email: "jean.dupont@example.com",
                    relationship: "Père",
                },
            ],
        }),
    });
};

export const _getUserDetail = async (userId) => {
    return fetcher(BASE_URL_API + `/suivi-onboarding/user/${userId}/details`, {
        method: "GET",
        credentials: "include",
    });
};

export const _renewTrialPeriod = async (data) => {
    const user = useAuthStore.getState().infos;
    const new_prob_end_date = data?.new_date;
    const user_id = data?.user_id;

    return fetcher(
        BASE_URL_API +
            `/onboarding/user/${
                user_id?.id_user ?? user_id?.id_task
            }/step/change_prob_end_date`,
        {
            method: "PATCH",
            // credentials: "include",
            headers: {
                "Content-Type": "application/json", // Définir le type de contenu
                Authorization: `Bearer ${user?.access}`,
            },
            body: JSON.stringify({
                new_prob_end_date,
            }),
        }
    );
};
export const _changeStartDate = async (data) => {
    const user = useAuthStore.getState().infos;
    const new_starting_date = data?.new_date;
    const user_id = data?.user_id;

    return fetcher(
        BASE_URL_API +
            `/onboarding/user/${
                user_id?.id_user ?? user_id?.id_task
            }/step/change_starting_date`,
        {
            method: "PATCH",
            // credentials: "include",
            headers: {
                "Content-Type": "application/json", // Définir le type de contenu
                Authorization: `Bearer ${user?.access}`,
            },
            body: JSON.stringify({
                new_starting_date,
            }),
        }
    );
};

export const _getSuiviUserDetail = async (userId) => {
    return fetcher(BASE_URL_API + `/suivi-onboarding/user/${userId}/details`, {
        method: "GET",
        credentials: "include",
    });
};

export const getAllOnboardingUser = (agencies) => {
    // return fetcher(`${BASE_URL_API}/users/search?q=${user}`, {
    //     method: "GET",
    //     credentials: "include",
    // });

    return fetcher(
        `${BASE_URL_API}/onboarding/agency/${agencies}/filter/users`,
        {
            method: "GET",
            credentials: "include",
        }
    );
};
